import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const BoardVisibilityButtonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardVisibilityButton"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionLevel"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"BoardVisibilityButton","document":BoardVisibilityButtonDocument}} as const;
export type BoardVisibilityButtonQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID']['input'];
}>;


export type BoardVisibilityButtonQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id' | 'closed' | 'idEnterprise' | 'idOrganization'>
    & { prefs?: Types.Maybe<(
      { __typename: 'Board_Prefs' }
      & Pick<Types.Board_Prefs, 'permissionLevel'>
    )> }
  )> }
);

/**
 * __useBoardVisibilityButtonQuery__
 *
 * To run a query within a React component, call `useBoardVisibilityButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardVisibilityButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardVisibilityButtonQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useBoardVisibilityButtonQuery(
  baseOptions: TrelloQueryHookOptions<
    BoardVisibilityButtonQuery,
    BoardVisibilityButtonQueryVariables
  > &
    (
      | { variables: BoardVisibilityButtonQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: BoardVisibilityButtonDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    BoardVisibilityButtonQuery,
    BoardVisibilityButtonQueryVariables
  >(BoardVisibilityButtonDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useBoardVisibilityButtonLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    BoardVisibilityButtonQuery,
    BoardVisibilityButtonQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BoardVisibilityButtonQuery,
    BoardVisibilityButtonQueryVariables
  >(BoardVisibilityButtonDocument, options);
}
export function useBoardVisibilityButtonSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        BoardVisibilityButtonQuery,
        BoardVisibilityButtonQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BoardVisibilityButtonQuery,
    BoardVisibilityButtonQueryVariables
  >(BoardVisibilityButtonDocument, options);
}
export type BoardVisibilityButtonQueryHookResult = ReturnType<
  typeof useBoardVisibilityButtonQuery
>;
export type BoardVisibilityButtonLazyQueryHookResult = ReturnType<
  typeof useBoardVisibilityButtonLazyQuery
>;
export type BoardVisibilityButtonSuspenseQueryHookResult = ReturnType<
  typeof useBoardVisibilityButtonSuspenseQuery
>;
export type BoardVisibilityButtonQueryResult = Apollo.QueryResult<
  BoardVisibilityButtonQuery,
  BoardVisibilityButtonQueryVariables
>;
